module.exports = __webpack_public_path__ + "static/img/null-2.5f288be1.png";